import React, { ReactNode } from "react";
import cx from "classnames";

type Props = {
  children: ReactNode;
  className?: string;
};

const style = { gridArea: "1/1" };

const Overlay: React.FC<Props> = ({ children, className }) => (
  <div className={cx("relative grid", className)} style={style}>
    {children}
  </div>
);

const Container: React.FC<Props> = ({ children, className }) => (
  <div className={cx("grid", className)}>{children}</div>
);

export const BackgroundImage = { Overlay, Container, style };
